export default function getVersion() {
  return window.GLOBAL_CONFIG.VERSION;
}
